import axios from 'axios';

const API_URL = '/api/tenant/legacy-reports';

let catalogPromise = null;

const cleanParams = (params = {}) => {
  const queryParams = { ...params };
  Object.keys(queryParams).forEach((key) => {
    if (queryParams[key] === undefined || queryParams[key] === null || queryParams[key] === '') {
      delete queryParams[key];
    }
  });
  return queryParams;
};

/**
 * Catálogo de reportes legacy iTPV 3.0 (grupos + reportes con filtros y
 * columnas). Se cachea en memoria porque es estático por versión del backend.
 */
export const fetchReportsCatalog = async () => {
  if (!catalogPromise) {
    catalogPromise = axios
      .get(`${API_URL}/catalog`)
      .then((response) => response.data)
      .catch((error) => {
        catalogPromise = null;
        throw error;
      });
  }
  return catalogPromise;
};

/** Catálogos para los selectores de filtros (almacenes, categorías, vendedores, cajas, clientes). */
export const fetchFilterCatalogs = async () => {
  const response = await axios.get(`${API_URL}/filters`);
  return response.data;
};

/** Ejecuta un reporte con los filtros dados y devuelve { rows, meta }. */
export const fetchReportData = async (reportId, params) => {
  const response = await axios.get(`${API_URL}/${reportId}/data`, {
    params: cleanParams(params),
  });
  return response.data;
};

/** Descarga el reporte en Excel (blob). */
export const downloadReportExcel = async (reportId, params) => {
  const response = await axios.get(`${API_URL}/${reportId}/download`, {
    params: cleanParams(params),
    responseType: 'blob',
  });
  return response.data;
};
